export const formError = {
  "form_error_required": "Este campo es obligatorio",
  "form_default_error": "Entrada inválida",
  "form_error_email": "Este correo electrónico no es válido",
  "form_error_email_password": "La contraseña debe contener mayúsculas, minúsculas y símbolos",
  "form_error_min": "Debe tener al menos {{min}} caracteres",
  "form_error_email_confirm_password": "Las contraseñas no son idénticas",
  "form_error_phone": "El número de teléfono no es válido",
  "form_error_email_or_phone_required": "Se requiere correo electrónico o número de teléfono",
  "form_error_nir": "This social security number is not valid (check the 15 digits and the control key).",
  "form_error_nir_birthdate_invalid": "This date of birth is not valid.",
  "form_error_nir_birthdate_mismatch": "This date of birth does not match your social security number (birth year and month).",
}
